import { initializeApp, getApps } from 'firebase/app'
import { getAnalytics, isSupported as analyticsSupported } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyAVdHV2Mx4kB50gNzJF9CbjpM1NFuxSaTc",
    authDomain: "gymdesk-suite.firebaseapp.com",
    projectId: "gymdesk-suite",
    storageBucket: "gymdesk-suite.firebasestorage.app",
    messagingSenderId: "945437176562",
    appId: "1:945437176562:web:6ce1e41226df632aa9566b",
    measurementId: "G-0DQLDC0X45"
  };  

// Prevent re-init during HMR
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)

// Core services
const auth = getAuth(app)
const db = getFirestore(app)
const storage = getStorage(app)
const functions = getFunctions(app, 'us-central1')

// Analytics (browser-only, guards SSR/tests)
let analytics = null
if (typeof window !== 'undefined') {
  analyticsSupported().then((ok) => {
    if (ok) analytics = getAnalytics(app)
  })
}

export { app, auth, db, storage, functions, analytics }